import { ProductInventorySettingsBuilder } from "../builders";

export class ProductInventorySettings {
  public readonly price: number;
  public readonly max: number;
  public readonly limit: number;

  constructor(builder: ProductInventorySettingsBuilder) {
    this.price = builder.price;
    this.max = builder.max;
    this.limit = builder.limit;
  }

  toJSON() {
    return {
      price: this.price ? this.price * 100 : null,
      max: this.max ? this.max : null,
      limit: this.limit ? this.limit : null
    };
  }
}
